export default {
  pending: 'pending',
  processing: 'processing',
  cancel: 'cancel',
  hold: 'hold',
  completed: 'completed',
  unknown: 'unknown',
}

export const validTransitions = {
  pendingDispatch: ['cancel'],
  pending: ['accepted', 'hold', 'cancel', 'rejected'],
  accepted: ['processing', 'cancel', 'pending'],
  processing: ['cancel', 'pendingPrice', 'pending'],
  hold: ['cancel', 'processing', 'pending'],
  pendingPrice: ['cancel', 'completed', 'pending'],
  completed: ['pending'],
}
